import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api';

const ActivateAccountPage = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('Ativando sua conta...');

  useEffect(() => {
    let mounted = true;

    const activate = async () => {
      try {
        const response = await api.get(`/auth/activate-account/${token}`);
        if (!mounted) return;
        setSuccess(true);
        setMessage(response.data?.message || 'Conta ativada com sucesso.');
      } catch (error) {
        if (!mounted) return;
        setSuccess(false);
        setMessage(error?.response?.data?.detail || 'Não foi possível ativar sua conta.');
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if (token) activate();
    else {
      setLoading(false);
      setSuccess(false);
      setMessage('Token de ativação inválido.');
    }

    return () => {
      mounted = false;
    };
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white border rounded-xl shadow-sm p-6 text-center">
        {loading ? (
          <>
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-purple-600 mx-auto mb-4"></div>
            <h1 className="text-xl font-semibold text-gray-900">Ativando sua conta</h1>
            <p className="text-sm text-gray-600 mt-2">Aguarde enquanto validamos seu link.</p>
          </>
        ) : (
          <>
            <h1 className={`text-xl font-semibold ${success ? 'text-emerald-700' : 'text-red-700'}`}>
              {success ? 'Conta ativada' : 'Falha na ativação'}
            </h1>
            <p className="text-sm text-gray-700 mt-3">{message}</p>
            <Link to="/login" className="inline-flex mt-6 px-4 py-2 rounded-md bg-purple-600 text-white hover:bg-purple-700">
              Ir para o login
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default ActivateAccountPage;
